import React, { useMemo } from "react";
import { Check } from "lucide-react";
import { DateRange } from "../types/PerformanceTypes";
import { dateInputCls, formatDateLabel, shiftRangeBack } from "../utils/headerUtils";

interface Props {
  primary:  DateRange;
  compare:  DateRange;
  onChange: (r: DateRange) => void;
}

const CompareRangeRow: React.FC<Props> = ({ primary, compare, onChange }) => {
  const suggested   = useMemo(() => shiftRangeBack(primary), [primary]);
  const isSuggested = compare.startDate === suggested.startDate
                   && compare.endDate   === suggested.endDate;

  return (
    <div className="flex flex-wrap items-center gap-2 px-4 sm:px-6 py-2.5
      bg-gradient-to-r from-violet-50 to-white border-b border-violet-100">

      {/* Période A badge */}
      <span className="flex items-center gap-1 px-2 py-1 rounded-md
        text-[11px] font-semibold bg-[#0F52BA] text-white">
        <span className="w-1.5 h-1.5 rounded-full bg-white/70" />
        Période A
        <span className="font-normal opacity-80 ml-0.5 hidden sm:inline">
          {formatDateLabel(primary.startDate)} – {formatDateLabel(primary.endDate)}
        </span>
      </span>

      <span className="text-slate-300 text-sm hidden sm:inline">vs</span>

      {/* Période B badge */}
      <span className="flex items-center gap-1 px-2 py-1 rounded-md
        text-[11px] font-semibold bg-violet-600 text-white">
        <span className="w-1.5 h-1.5 rounded-full bg-white/70" />
        Période B
      </span>

      {/* Date inputs */}
      <div className="flex flex-wrap items-center gap-2 w-full sm:w-auto">
        <input
          type="date"
          value={compare.startDate}
          onChange={e => onChange({ ...compare, startDate: e.target.value })}
          className={`${dateInputCls} border-violet-200 focus:border-violet-400 focus:ring-violet-100`}
        />
        <span className="text-slate-300 text-sm hidden sm:inline">–</span>
        <input
          type="date"
          value={compare.endDate}
          onChange={e => onChange({ ...compare, endDate: e.target.value })}
          className={`${dateInputCls} border-violet-200 focus:border-violet-400 focus:ring-violet-100`}
        />
      </div>

      {/* Période précédente suggestion */}
      {!isSuggested ? (
        <button
          onClick={() => onChange(suggested)}
          className="px-2.5 py-1 rounded-lg text-[11px] font-medium border
            border-violet-200 text-violet-600 bg-white hover:bg-violet-50
            whitespace-nowrap transition-colors"
        >
          ← Période précédente
        </button>
      ) : (
        <span className="flex items-center gap-1 px-2.5 py-1 rounded-lg text-[11px]
          border border-violet-200 text-violet-400 bg-violet-50/60 whitespace-nowrap">
          <Check size={10} /> Période précédente
        </span>
      )}
    </div>
  );
};

export default CompareRangeRow;